'use strict';

// eslint-disable-next-line max-len, max-params, max-lines-per-function
angular.module('webAgro1App').controller('ResumoOcorrenciasIndicadoresCtrl', function($scope, $rootScope, $location,
  LoadingService, MessagesService, ResumoOcorrenciasIndicadoresService, Flash, $routeParams, PeriodSelectService,
  OperacoesService, OperacoesDadosService, $templateCache) {
  $scope.cultivares = [];
  $scope.resumoOcorrenciasIndicadores = [];
  $scope.periodo = {};

  const listOccurrencesSummary = function() {
    LoadingService.showLoading();

    $scope.resumoOcorrenciasIndicadores = null;
    const filters = getFilters();

    return ResumoOcorrenciasIndicadoresService.getSummary(filters).then(function(result) {
      $scope.resumoOcorrenciasIndicadores = result;
      if (result.cultivares && !$scope.filters.cultivar) {
        $scope.cultivares = result.cultivares;
        if ($scope.cultivares.length === 1) {
          $scope.filters.cultivar = $scope.cultivares[0].cultivar;
        }
      }
    }, function() {
      MessagesService.alert('Falha ao carregar dados, tente novamente mais tarde');
    })
      .finally(LoadingService.hideLoading);
  };

  $scope.$on('occurrencesSummary', function() {
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.ocorrencia.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.filters = {
        cultivar: null
      };
      listOccurrencesSummary().then(() => {
        const date = $routeParams.date || $routeParams.historyDate;
        if (date) {
          $scope.filters = {
            ...$scope.filters,
            dataInicial: moment(date)._d,
            dataFinal: moment(date)._d
          };
        }
      });
    }, $rootScope.errorRootInitialize);
  });

  $scope.setCultivar = function(cultivar, event) {
    preventDefault(event);
    $scope.filters.cultivar = cultivar;
    listOccurrencesSummary();
  };

  $scope.openPeriodsFilter = function(event) {
    preventDefault(event);

    PeriodSelectService
      .openPeriodSelection($scope.periodo, $scope.filters)
      .then($scope.setPeriodo);
  };

  $scope.setPeriodo = function(periodo, event) {
    preventDefault(event);

    if (periodo) {
      $scope.filters.dataInicial = periodo.dataInicial;
      $scope.filters.dataFinal = periodo.dataFinal;
      $scope.periodo.periodo = periodo.descricao;
    }

    listOccurrencesSummary().then(setMarkers);
  };

  function setMarkers() {
    LoadingService.showLoading();

    const filters = {
      gleba: { id: +$routeParams.activeGleba },
      startDate: moment($scope.filters.dataInicial).format('YYYY-MM-DD'),
      endDate: moment($scope.filters.dataFinal).format('YYYY-MM-DD'),
      tipo: 'doenca'
    };

    const template = $templateCache.get('views/infowindow_templates/infowindowoperations.tpl.html');
    OperacoesService.getOperationsDayGleba(filters).then((result) => (
      OperacoesDadosService.newGetMarkersOperationsDayGleba(
        result.data, null, template
      ).reduce(function(innerResult, record) {
        innerResult[record.marker.tipo] = innerResult[record.marker.tipo] || [];
        innerResult[record.marker.tipo].push(record);
        return innerResult;
      }, {})
    ))
      .then(showAllMarkers)
      .finally(LoadingService.hideLoading);
  }

  function showAllMarkers(activities) {
    $scope.$emit('setMarkers', Object.values(activities || {}).reduce((group, data) => group.concat(data), []));
  }

  function getFilters() {
    $scope.data = $routeParams.date || $routeParams.historyDate;
    $scope.gleba = $scope.$root.currentPropriedade.glebas.find(function(gleba) {
      return gleba.id === +$routeParams.activeGleba;
    });
    const filters = { ...$scope.filters };

    if (!filters.dataInicial && !filters.dataFinal) {
      filters.data = $scope.data;
    } else {
      filters.start_date = moment(filters.dataInicial).format('YYYY-MM-DD');
      filters.end_date = moment(filters.dataFinal).format('YYYY-MM-DD');
      delete filters.dataInicial;
      delete filters.dataFinal;
    }

    filters.gleba = +$routeParams.activeGleba;

    // altera filtro para enviar apenas a id da cultivar e nao o objeto inteiro
    filters.cultivar = filters.cultivar ? filters.cultivar.id : null;

    return filters;
  }
});
